const logger = (data) => {
	if (process.env.REACT_APP_ENV !== 'prod') {
		console.info('LOGGER', data);
	}
};

export default logger;
